import { GlobalStyle as BaseGlobalStyle } from '@melements/front-components';
import { NotificationsContextProvider } from '@melements/front-components/dist/context';
import * as Sentry from '@sentry/browser';
import { SentryBoundary } from 'app/sentry/SentryBoundary';
import 'core-js/stable';
import React from 'react';
import { AuthenticationState, AzureAD } from 'react-aad-msal';
import 'react-app-polyfill/ie11';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import 'regenerator-runtime/runtime';
import { LocaleProvider } from 'shared/localeProvider/LocaleProvider';
import { createStore } from 'store/store';
import { ThemeProvider } from 'styled-components';
import { Theme } from 'theme';
import { getEnvironmentVar } from 'utils';

import { App } from './app/App';
import { authProvider } from './app/authorization/authProvider';
import { GlobalStyle } from './index.styles';
import { Loader } from './shared';

if (getEnvironmentVar('REACT_APP_SENTRY_KEY') && getEnvironmentVar('REACT_APP_SENTRY_PROJECT')) {
  Sentry.init({
    dsn: `https://${getEnvironmentVar('REACT_APP_SENTRY_KEY')}@sentry.io/${getEnvironmentVar(
      'REACT_APP_SENTRY_PROJECT',
    )}`,
  });
}

const store = createStore() as any;

ReactDOM.render(
  <SentryBoundary>
    <Provider store={store}>
      <ThemeProvider theme={Theme}>
        <LocaleProvider locale="en">
          <NotificationsContextProvider>
            <BaseGlobalStyle />
            <GlobalStyle />
            <AzureAD provider={authProvider} reduxStore={store} forceLogin={true}>
              {({
                logout,
                authenticationState,
                accountInfo,
              }: {
                logout: any;
                authenticationState: any;
                accountInfo: any;
              }) => {
                if (authenticationState === AuthenticationState.Authenticated && accountInfo.jwtAccessToken) {
                  return <App logoutFunction={logout} accountInfo={accountInfo} />;
                }

                return <Loader className="loader" />;
              }}
            </AzureAD>
          </NotificationsContextProvider>
        </LocaleProvider>
      </ThemeProvider>
    </Provider>
  </SentryBoundary>,
  document.getElementById('admin-portal'),
);
